var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartGrayscale = function SvgChartGrayscale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEBEC",
    fillRule: "evenodd",
    d: "m6.527 30.793 17.73.022.031-24.72L4.025 6.07l-.028 22.248c-.002 1.366 1.13 2.474 2.53 2.475",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "chart_grayscale_svg__a",
    width: 25,
    height: 29,
    x: 2,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 4.119h24.288v28.647H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_grayscale_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "m26.288 4.148-1.997-.003-20.264-.024L2.03 4.12l-.002 1.949L2 28.316c-.003 2.438 2.027 4.423 4.524 4.427l17.73.02 1.998.003.002-1.949.031-24.72zm-2 1.946-.03 24.72-17.731-.02c-1.4-.002-2.532-1.11-2.53-2.476L4.025 6.07z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M8.241 10.332 8.24 12.28l11.82.014.002-1.95zM8.233 17.225l6.754.008.002-1.95-6.754-.007z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M33.11 15.14a2.81 2.81 0 0 0 .005-4.045 2.98 2.98 0 0 0-4.144-.005L16.974 22.77l4.14 4.05z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m16.968 22.77 4.14 4.05-5.03.857z",
    clipRule: "evenodd"
  })));
};
export default SvgChartGrayscale;